const CourseModel = {
  created: "date",
  updated: "date",
  thumbnail: "object",
  background_image: "object",
  cover_image: "object",
  lessons: ["hasMany", "lesson"],
}

export default CourseModel
